"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileSectionsDataMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class ProfileSectionsDataMapper {
    toDomain(result) {
        const isLoading = lodash_1.default.get(result, "loading");
        const email = lodash_1.default.get(result, "data.getUser.email");
        const userOptins = lodash_1.default.get(result, "data.getUser.userOptins");
        const virtualTicket = lodash_1.default.get(result, "data.getUser.virtualTicket");
        const mfaEnabled = lodash_1.default.get(result, "data.getUser.mfaEnabled");
        return {
            isLoading,
            email,
            userOptins,
            virtualTicket,
            mfaEnabled,
        };
    }
}
exports.ProfileSectionsDataMapper = ProfileSectionsDataMapper;
